import { Storage } from 'react-jhipster';
import { createSlice } from '@reduxjs/toolkit';
import { LOCAL_STORAGE_KEYS } from "app/shared/util/local-storage-keys";

export const AUTH_TOKEN_KEY = 'authenticationTokenPub';
export const KEYCLOAK_ID_TOKEN = 'keycloakIdTokenPub';

export const KEYCLOAK_LOGIN_CLICKED = 'keycloakLoginClicked';
export const USER_ROLE_KEY = 'userRolePub';

export const initialState = {
  loading: false,
  isAuthenticated: false,
  loginSuccess: false,
  loginError: false, // Errors returned from server side
  account: {} as any,
  errorMessage: null as unknown as string, // Errors returned from server side
  redirectMessage: null as unknown as string,
  sessionHasBeenFetched: false,
  idToken: null as unknown as string,
  logoutUrl: null as unknown as string,
};

export type AuthenticationState = Readonly<typeof initialState>;

export const clearAuthToken = () => {
  if (Storage.local.get(AUTH_TOKEN_KEY)) {
    Storage.local.remove(AUTH_TOKEN_KEY);
  }
};

export const clearAuthentication = errorMessage => dispatch => {
  clearAuthToken();
  localStorage.removeItem(LOCAL_STORAGE_KEYS.PENDING_NIAS_NAVBAR);

  dispatch(authError(errorMessage));
  dispatch(logoutUser());
};

export const AuthenticationSlice = createSlice({
  name: 'authentication',
  initialState: initialState as AuthenticationState,
  reducers: {
    successLogin(state, action) {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.PENDING_NIAS_NAVBAR);
      return {
        ...state,
        loading: false,
        loginError: false,
        loginSuccess: true,
        isAuthenticated: true,
        sessionHasBeenFetched: true,
        account: action.payload,
      };
    },
    loginFailure(state, action) {
      return {
        ...initialState,
        errorMessage: action.payload,
        loading: false,
        loginError: true,
      }
    },
    logoutUser() {
      clearAuthToken();
      window.location.href = '/logout';

      return {
        ...initialState,
      };
    },
    authError(state, action) {
      return {
        ...state,
        errorMessage: action.payload,
        loginError: true,
        loading: false,
      };
    },
    clearAuth(state) {
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
      };
    },
    loadedNotAuthenticated(state) {
      return {
        ...state,
        loading: false,
      };
    },
  },
});

export const { successLogin, loginFailure, clearAuth, authError, logoutUser, loadedNotAuthenticated } = AuthenticationSlice.actions;

// Reducer
export default AuthenticationSlice.reducer;
